export const BASE_URL = process.env.REACT_APP_BASE_URL
export const INITIALIZE_TRANSACTION = 'transactions'
export const VERIFY_TRANSACTION = 'transactions/verify'
export const SIGNUP_URL = 'auth/register'
export const LOGIN_URL ='auth/login'
export const LOGOUT_URL ='auth/logout'
export const REFRESH_TOKENS_URL = 'auth/refresh-tokens'
export const FORGOT_PASSWORD_URL ='auth/forgot-password'
export const RESET_PASSWORD_URL = 'auth/reset-password'
export const VERIFY_EMAIL = 'auth/verify-email'
export const ANALYTICS_URL = 'users/d/dashboard'
export const COURSE_MODULES_URL = 'course_modules'
export const GET_ROLES_URL = 'users/is_email_taken'
export const CLOUDINARY_BASE_URL = process.env.REACT_APP_CLOUDINARY_BASE_URL
export const UPLOAD_THUMBNAIL = 'image/upload'
export const UPLOAD_VIDEO = 'video/upload'
export const UPLOAD_RAW_FILE = 'raw/upload'
export const CONTACT_URL = 'contact_messages'
export const COURSE_MODULES_BRIEF_URL = 'course_modules/brief'
